import onboardingReducer from "./reducers/onboardingReducer";

export default onboardingReducer;
